import {
  DropDown,
  H1,
  TextAreaWithLabelAndError,
} from "@collabodoc/component-library";
import React, { useContext } from "react";
import { Col, Row } from "react-bootstrap";
import { BackFrontButton } from "../../components/BackFrontButtons";
import { RegistrationContext } from "../../RegistrationContext";

import { FormattedMessage, useIntl } from "react-intl";
import { RCVIEWS } from "../../URLS";
import { useNavigate } from "react-router-dom";

const PatientQuestionView = () => {
  const intl = useIntl();

  const { contactReasons } = useContext(RegistrationContext);
  const {
    contactReasonId,
    setContactReasonId,
    message,
    setMessage,
    subjectState,
  } = useContext(RegistrationContext);
  const navigate = useNavigate();

  const handleClick = (e) => {
    e.preventDefault();
    navigate(RCVIEWS.FQUESTIONS);
  };

  const handleInput = (input) => {
    setMessage((prevState) => ({
      ...prevState,
      patientText: input,
    }));
  };

  const handleBack = () => {
    if (subjectState.isSelf) {
      navigate(RCVIEWS.CHOOSEISSUEOWNER);
    } else {
      navigate(RCVIEWS.REGISTERCHILD);
    }
  };

  const options = contactReasons?.map(({ id, name }) => {
    return {
      id: id,
      text: name,
    };
  });

  return (
    <Row>
      <Col md={{ span: 8, offset: 2 }}>
        <H1>
          <FormattedMessage id="patientquestion.header" />
        </H1>
        <Row>
          <Col>
            <label className="question boldText" htmlFor={"contactReason"}>
              <FormattedMessage id="patientquestion.contactreason.choose" />
              <span className="asterisk"> *</span>
            </label>
            <DropDown
              placeholder={intl.formatMessage({
                id: "patientquestion.contactreason.choose",
              })}
              options={options}
              handler={(cr) => setContactReasonId(cr)}
              sort={true}
            ></DropDown>
          </Col>
        </Row>
        <br />
        <Row>
          <Col>
            <TextAreaWithLabelAndError
              id={"PatientMessage"}
              label={intl.formatMessage({
                id: "relativecontact.patientquestion.patientmessage.title",
              })}
              placeholder={intl.formatMessage({
                id: "patientquestion.patientmessage.placeholder",
              })}
              required={true}
              value={message.patientText}
              minRows={4}
              maxLength={500}
              handleChange={handleInput}
            />
          </Col>
        </Row>
        <br />
        <BackFrontButton
          disabled={!message.patientText || !contactReasonId}
          handleBack={handleBack}
          handleForward={handleClick}
          backBtnText={intl.formatMessage({ id: "back" })}
          forwardBtnText={intl.formatMessage({ id: "next" })}
        />
      </Col>
    </Row>
  );
};
export default PatientQuestionView;
